module.exports = __webpack_public_path__ + "static/media/milage.e92c0dc6.png";